export const tokens = {
    color: {
        background: {
            primary: "#D99C8D",         // Main section background (dusty rose)
            secondary: "#fffdf9",       // Light paper background
            Pink: "#f8d1cd66",
            Green: "#EDF9EB",
            gradient: {
                start: "#D4A99D",         // Soft peach
                end: "#1E5C5D",           // Deep teal
            },
            accent: {
                gold: "#B88B67",
            },
            tertiary: "#fae7e0",       // Light beige for cards and sections
            quaternary: "#F9F9F9",     // Very light background for subtle sections
            quinary: "#F0F0F0",        // Light gray for
        },

        feedback: {
            success: "#22C55E", // green-500
            error: "#EF4444",   // red-500
            warning: "#F59E0B", // yellow-500
            info: "#3B82F6",    // blue-500
            successBg: "#ECFDF5", // light green background
            errorBg: "#FEF2F2",   // light red background
            warningBg: "#FFFBEB", // light yellow background
            infoBg: "#EFF6FF",

        },
        primary: {
            base: "#1E5C5D",            // Main brand teal
            dark: "#143F40",            // Hover/pressed
            light: "#4B858B",           // Accent highlight
            subtle: "#D6EAEA",          // Light accent for backgrounds
        },
        secondary: {
            base: "#B58473",
            light: "#D4A99D",
        },

        accent: {
            gold: "#B88B67",
        },
        text: {
            primary: "#2F3E3F",
            secondary: "#6C8182",
            light: "#FBF7F0",
            onPrimary: "#FBF7F0",
        },
        border: {
            base: "#C6ADAD",
            subtle: "#EBEAE8",
            primary: "#2F3E3F",
        },
        ui: {
            paper: "#FBF7F0",
            tape: "#EBEAE8",
        },
    },

    font: {
        family: {
            base: 'Inter, "Helvetica Neue", Arial, sans-serif',
            heading: 'Montserrat, "Helvetica Neue", Arial, sans-serif',
            display: 'Playfair Display, serif',
        },
        size: {
            base: "1rem",        // 16px
            sm: "0.875rem",      // 14px
            md: "1.125rem",      // 18px
            lg: "1.25rem",       // 20px

            heading: {
                hero: "3.5rem",    // 56px
                h1: "2.5rem",      // 40px
                h2: "2rem",        // 32px
                h3: "1.75rem",     // 28px
                h4: "1.5rem",      // 24px
                h5: "1.25rem",     // 20px
                h6: "1rem",        // 16px
            },
        },
        weight: {
            light: 300,
            normal: 400,
            medium: 500,
            semibold: 600,
            bold: 700,
        },
        lineHeight: {
            base: 1.6,
            heading: 1.2,
        },
    },

    card: {
        width: "400px",
        height: "500px",
        maxWidth: "100%",
        margin: "0 auto",
        alignSelf: "center",
        justifySelf: "center",
    },

    space: {
        0: "0px",
        2: "4px",
        4: "8px",
        8: "16px",
        12: "24px",
        16: "32px",
        24: "48px",
        32: "64px",
        48: "96px",
        64: "128px",
    },

    radius: {
        none: "0px",
        sm: "4px",
        md: "8px",
        lg: "16px",
        full: "50%",
    },

    // shadow: {
    //     sm: "0 1px 2px rgba(0, 0, 0, 0.05)",
    //     md: "0 4px 8px rgba(0, 0, 0, 0.08)",
    //     lg: "0 8px 16px rgba(0, 0, 0, 0.12)",
    //     hover: "0 6px 12px rgba(0, 0, 0, 0.1)",
    // },
    shadow: {
        sm: "0 0 2px 1px rgba(0, 0, 0, 0.05)",
        md: "0 0 6px 2px rgba(0, 0, 0, 0.08)",
        lg: "0 0 12px 3px rgba(0, 0, 0, 0.12)",
        hover: "0 0 10px 2px rgba(0, 0, 0, 0.1)",
    },

    breakpoint: {
        sm: "480px",
        md: "768px",
        lg: "1024px",
        xl: "1280px",
        xxl: "1440px",
    },

    cursor: {
        pointer: 'pointer',
        default: 'default',
        notAllowed: 'not-allowed',
        wait: 'wait',
    },

    layout: {
        display: {
            inlineFlex: 'inline-flex',
            block: 'block',
            flex: 'flex',
            grid: 'grid',
        },
        center: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
        },
        align: {
            center: 'center',
            start: 'flex-start',
            end: 'flex-end',
        },
        justify: {
            center: 'center',
            between: 'space-between',
            around: 'space-around',
        },


    },

    spacing: {
        0: '0px',
        px: '1px',
        0.5: '2px',
        1: '4px',
        1.5: '6px',
        2: '8px',
        2.5: '10px',
        3: '12px',
        3.5: '14px',
        4: '16px',
        5: '20px',
        6: '24px',
        8: '32px',
        10: '40px',
        12: '48px',
        16: '64px',
        20: '80px',
        24: '96px',
        32: '128px',
        40: '160px',
        48: '192px',
        56: '224px',
        64: '256px',
    },

    grid: {
        columns: 12,
        gutter: '16px',
        maxWidth: '1280px',
    },

    typography: {
        fontFamily: {
            sans: '"Inter", system-ui, sans-serif',
            serif: '"Merriweather", serif',
            mono: '"Fira Code", monospace',
        },
        fontSize: {
            xs: '0.75rem',      // 12px
            sm: '0.875rem',     // 14px
            base: '1rem',       // 16px
            lg: '1.125rem',     // 18px
            xl: '1.25rem',      // 20px
            '2xl': '1.5rem',    // 24px
            '3xl': '1.875rem',  // 30px
            '4xl': '2.25rem',   // 36px
            '5xl': '3rem',      // 48px
        },
        fontWeight: {
            light: 300,
            normal: 400,
            medium: 500,
            semibold: 600,
            bold: 700,
        },
        lineHeight: {
            none: '1',
            tight: '1.25',
            snug: '1.375',
            normal: '1.5',
            relaxed: '1.625',
            loose: '2',
        },
        // ✅ Add this block:
        text: {
            decoration: {
                none: 'none',
                underline: 'underline',
                lineThrough: 'line-through',
            },
        },
    },

    radii: {
        none: '0px',
        sm: '4px',
        md: '8px',
        lg: '12px',
        xl: '16px',
        full: '9999px',
    },

    shadows: {
        xs: '0 0 0 1px rgba(0, 0, 0, 0.05)',
        sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
        md: '0 4px 6px rgba(0, 0, 0, 0.1)',
        lg: '0 10px 15px rgba(0, 0, 0, 0.1)',
        xl: '0 20px 25px rgba(0, 0, 0, 0.15)',
    },

    zIndex: {
        auto: 'auto',
        0: 0,
        10: 10,
        20: 20,
        30: 30,
        40: 40,
        50: 50,
        dropdown: 100,
        header: 500,
        modal: 1000,
        tooltip: 1100,
    },

    breakpoints: {
        xs: '320px',
        sm: '640px',
        md: '768px',
        lg: '1024px',
        xl: '1280px',
        '2xl': '1536px',
    },

    maxWidth: {
        xs: '20rem',    // 320px
        sm: '24rem',    // 384px
        md: '28rem',    // 448px
        lg: '32rem',    // 512px
        xl: '36rem',    // 576px
        '2xl': '42rem', // 672px
        '3xl': '48rem', // 768px
        full: '100%',
    },

    interactions: {
        transitions: {
            default: 'all 150ms ease-in-out',
            fast: 'all 75ms ease-in-out',
            slow: 'all 300ms ease-in-out',
        },
        cursor: {
            pointer: 'pointer',
            notAllowed: 'not-allowed',
            wait: 'wait',
            default: 'default',
        },

        hover: {
            transform: 'translateY(-1px)', // ✅ Add this
            filter: 'brightness(1.05)',
            boxShadow: '0 6px 12px rgba(0, 0, 0, 0.1)', // ✅ Add this
        },
        active: {
            transform: 'scale(0.98)',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.08)', // ✅ Add this
        },
        focus: {
            ring: 'focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-primary',
        },
    },

    transitionProperty: {
        all: 'all',
        colors: 'color, background-color, border-color, text-decoration-color, fill, stroke',
        opacity: 'opacity',
        transform: 'transform',
        shadow: 'box-shadow',
        height: 'height',
        width: 'width',
        none: 'none',
        default: 'background-color, border-color, color, fill, stroke, opacity, box-shadow, transform',

    },

    aspectRatio: {
        square: '1 / 1',
        video: '16 / 9',
        golden: '1.618 / 1',
        portrait: '3 / 4',
        auto: 'auto',
    },

    opacity: {
        none: 0,
        disabled: 0.5,
        overlay: 0.8,
        muted: 0.6,
        full: 1,
    },

    borderWidth: {
        none: '0px',
        hairline: '1px',
        thin: '2px',
        thick: '4px',
    },

    borderStyle: {
        solid: 'solid',
        dashed: 'dashed',
        dotted: 'dotted',
    },

    states: {
        default: {
            background: '#F9FAFB',
            border: '#E5E7EB',
            text: '#111827',
        },
        hover: {
            background: '#E0F2FE',
            border: '#0EA5E9',
            text: '#111827',
        },
        active: {
            background: '#DBEAFE',
            border: '#1E40AF',
            text: '#111827',
        },
        disabled: {
            background: '#F3F4F6',
            border: '#D1D5DB',
            text: '#9CA3AF',
            opacity: 0.5,
        },
    },

    animations: {
        fadeIn: 'fade-in 150ms ease-in-out',
        slideUp: 'slide-up 300ms ease-out',
        bounce: 'bounce 1s infinite',
        pulse: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite',
    },

    keyframes: {
        fadeIn: {
            from: { opacity: '0' },
            to: { opacity: '1' },
        },
        slideUp: {
            '0%': { transform: 'translateY(100%)' },
            '100%': { transform: 'translateY(0)' },
        },
        bounce: {
            '0%, 100%': { transform: 'translateY(-25%)', animationTimingFunction: 'cubic-bezier(0.8, 0, 1, 1)' },
            '50%': { transform: 'translateY(0)', animationTimingFunction: 'cubic-bezier(0, 0, 0.2, 1)' },
        },
        pulse: {
            '0%, 100%': { opacity: '1' },
            '50%': { opacity: '0.5' },
        }
    },

    transparencyOverlays: {
        light: 'rgba(255, 255, 255, 0.6)',
        dark: 'rgba(0, 0, 0, 0.5)',
        blurLight: 'backdrop-blur-sm bg-white/60',
        blurDark: 'backdrop-blur-sm bg-black/50',
    },

    iconSize: {
        sm: '16px',
        md: '20px',
        lg: '24px',
        xl: '32px',
    },

    size: {
        sm: "5rem",
        md: "24rem",    // 384px
        lg: "32rem",    // 512px
        xl: "40rem",    // 640px
        full: "100%",
        auto: "auto",
    },

    height: {
        auto: "auto",
        sm: "20rem",      // 320px
        md: "24rem",      // 384px
        lg: "32rem",      // 512px
        xl: "40rem",      // 640px
        "2xl": "48rem",   // 768px
        full: "100%",
        screen: "100vh",
        fit: "fit-content",
        min: "min-content",
        max: "max-content",
    },


    viewport: {
        fullHeight: '100vh',
        halfHeight: '50vh',
    },

    inset: {
        0: '0px',
        1: '0.25rem',
        2: '0.5rem',
        4: '1rem',
        8: '2rem',
        auto: 'auto',
        '1/2': '50%',
        half: '50%',
        full: '100%',
        '-1': '-0.25rem',
        '-2': '-0.5rem',
        '-4': '-1rem',
    },

    gridTemplateColumns: {
        1: 'repeat(1, minmax(0, 1fr))',
        2: 'repeat(2, minmax(0, 1fr))',
        3: 'repeat(3, minmax(0, 1fr))',
        4: 'repeat(4, minmax(0, 1fr))',
        5: 'repeat(5, minmax(0, 1fr))',
        6: 'repeat(6, minmax(0, 1fr))',
        12: 'repeat(12, minmax(0, 1fr))',
        sidebarMain: '300px 1fr',
    },

    motion: {
        duration: {
            instant: '50ms',
            fast: '150ms',
            medium: '300ms',
            slow: '500ms',
        },
        easing: {
            easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
            easeOut: 'cubic-bezier(0, 0, 0.2, 1)',
            easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
        }
    },

    layer: {
        base: 0,
        dropdown: 10,
        overlay: 20,
        modal: 30,
        toast: 40,
        tooltip: 50,
    },

    form: {
        borderColor: '#D1D5DB',
        focusColor: '#1E40AF',
        errorColor: '#DC2626',
        placeholderColor: '#9CA3AF',
    },


};
